export const setAccountPanel = (panel) => {

    return {
        type: 'SET_ACCOUNT_PANEL',
        panel
    };
};

export const setFoodItemPanel = (panel) => {

    return {
        type: 'SET_FOOD_ITEM_PANEL',
        panel
    };
};

export const setPizzaPanel = (panel) => {

    return {
        type: 'SET_PIZZA_PANEL',
        panel
    };
};

export const setSpecialPanel = (panel) => {

    return {
        type: 'SET_SPECIAL_PANEL',
        panel
    };
};

export const setCartPanel = (panel) => {
    return {
        type: 'SET_CART_PANEL',
        panel
    };
};

export const setHistoryPanel = (panel) => {
    return {
        type: 'SET_HISTORY_PANEL',
        panel
    };
};

export const resetPanels = () => {

    return {
        type: 'RESET_PANELS',
    };
};